import { render, staticRenderFns } from "./ProjectTile.vue?vue&type=template&id=3a62f9b6&scoped=true&"
import script from "./ProjectTile.vue?vue&type=script&lang=js&"
export * from "./ProjectTile.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTile.vue?vue&type=style&index=0&id=3a62f9b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a62f9b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
